var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { IconButton } from "@irati/ui/src/Button";
var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  top: -40px;\n  padding-left: 8px;\n  cursor: pointer;\n  ", " {\n    ", "\n  }\n"], ["\n  position: relative;\n  top: -40px;\n  padding-left: 8px;\n  cursor: pointer;\n  ", " {\n    ",
    "\n  }\n"])), IconButton, function (props) { return (props.hide && "\n      display: none;\n    "); });
export default IconWrapper;
var templateObject_1;
